<template>
    <div 
        class="bar-chart-container" 
        :style="[fullHeight ? { height: '100%' } : {}, 
        { justifyContent: verticalAlign },
        {gap: gap}
        ]">
        <div class="bar-chart-row" 
            v-for="(item, index) in computedData" :key="index"
        >
            <div class="num-area">
                <div class="percentage-box">{{ calculatePercentage(item.value) }}%</div>
                <div class="case-box">{{ formatCommaNumber(item.value) }}건</div>
            </div>
            <div class="bar-area">
                <div class="bar-fill"
                    :style="{ width: calculateChartPercentage(item.value) + '%' }"
                >

                </div>
            </div>
            <div class="bar-label">
                {{ item.label }}
            </div>
        </div>
    </div>
</template>

<script>
import {
    formatCommaNumber,
} from '@/utils/utils';
export default {
    props: {
        data: {
            type: Object,
        },
        verticalAlign: {
            type: String,
        },
        fullHeight: {
            type: Boolean,
        },
        gap: {
            type: String,
        }
    },
    computed: {
        computedData() {
            // 데이터를 배열로 변환
            const transformed = Object.entries(this.data).map(([label, value]) => ({
                label,
                value
            }));
            const totalValue = transformed.reduce((sum, item) => sum + item.value, 0);

            // 퍼센트 계산을 위해 최대값 찾기
            const maxValue = Math.max(...transformed.map(item => item.value));
            
            // 각 아이템에 퍼센트 추가
            return transformed.map(item => ({
                ...item,
                percentage: ((item.value / totalValue) * 100).toFixed(1),
                chartPercentage: ((item.value / maxValue) * 100).toFixed(1)
            }));
        },
    },
    data() {
        return {
            stats: null,
        }
    },
    watch: {
        computedData(newValue) {
            if(newValue) {
                this.stats = newValue;
            }
        }
    },
    methods: {
        formatCommaNumber,
        calculatePercentage(value) {
            const item = this.computedData.find(item => item.value === value);
            return item ? item.percentage : 0;
        },
        calculateChartPercentage(value) {
            const item = this.computedData.find(item => item.value === value);
            return item ? item.chartPercentage : 0;
        },
    }
}
</script>
<style lang="scss" scoped>

$Gray-5: #D1D6DB;
$Gray-10: #F1F2F3;
$Gray-20: #e8ebed;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$Yellow: #ffe414;
$SkyBlue : #E1F0FF;
$Blue : #278AEC;
$Red: #F55247;
$LightPink: #F7D7D4;
$Pink: #F8948E;
$Orange: #FFA50A;
$Green: #22BF22;
$LightGreen: #DAF1DA;

.bar-chart-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    max-width: 800px;
    margin: 0 auto;
}

.bar-chart-row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.num-area {
    width: 80px;
    .percentage-box {
        font-size: 14px;
        font-weight: bold;
        color: #333;
    }
      
      .case-box {
        font-size: 12px;
        color: #666;
    }
}

.bar-area {
    flex-grow: 1;
    height: 24px;
    background-color: transparent;
    margin-right: 20px;
    position: relative;
    overflow: hidden;
}

.bar-fill {
    height: 100%;
    background-color: #1626B6;
    width: 0%;
    border-radius: 6px;
    transition: width 0.5s ease-in-out;
}
  
.bar-label {
    width: 170px;
    font-size: 14px;
    color: #333;
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

}


</style>

